import React, { useState } from 'react'
import { FileType } from 'lucide-react'
import { genId } from '../lib/id'
import { readFileAsDataURL } from '../lib/fileRead'
import FileDropzone from '../components/FileDropzone'
import type { PdfCard } from '../types/LessonDoc'
import type { CardDef, CardEditorProps, CardPreviewProps } from './types'

const PDF_ACCEPT = { 'application/pdf': ['.pdf'] }

const Editor: React.FC<CardEditorProps> = ({ card, onChange }) => {
  const c = card as PdfCard
  const [busy, setBusy] = useState(false)

  const handleFile = async (file: File) => {
    setBusy(true)
    try {
      const dataUrl = await readFileAsDataURL(file)
      onChange({ pdfSrc: dataUrl, title: card.title || file.name.replace(/\.pdf$/i, '') })
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="space-y-2">
      <FileDropzone accept={PDF_ACCEPT} onFile={handleFile} busy={busy} label="Kéo-thả file .pdf" hint="Tài liệu PDF" />
      <label className="text-xs font-bold text-gray-500 uppercase">hoặc dán URL file PDF</label>
      <input
        className="w-full p-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-200"
        value={c.pdfSrc}
        onChange={(e) => onChange({ pdfSrc: e.target.value })}
        placeholder="https://.../tai-lieu.pdf"
      />
    </div>
  )
}

const Preview: React.FC<CardPreviewProps> = ({ card }) => {
  const c = card as PdfCard
  if (!c.pdfSrc) {
    return (
      <div className="p-4 rounded-lg bg-gray-50 border border-dashed border-gray-200 text-gray-400 text-sm text-center">
        Chưa có file PDF.
      </div>
    )
  }
  return (
    <iframe
      title={c.title || 'Tài liệu PDF'}
      src={c.pdfSrc}
      className="w-full rounded-lg border border-gray-200 bg-white"
      style={{ height: 600 }}
    />
  )
}

export const pdfCardDef: CardDef = {
  type: 'pdf',
  label: 'PDF',
  description: 'Nhúng tài liệu PDF',
  icon: FileType,
  color: 'bg-red-50 text-red-600',
  createDefault: (): PdfCard => ({ id: genId(), type: 'pdf', pdfSrc: '' }),
  Editor,
  Preview,
}
